(() => {
  'use strict';
  const mount = root => root.querySelectorAll('[data-collection-filter-form]').forEach(form => {
    const trigger = form.querySelector('[data-collection-filter-open]');
    const dialog = form.querySelector('[data-collection-filter-drawer]');
    if (!trigger || !dialog || dialog.dataset.mounted) return;
    dialog.dataset.mounted = 'true';
    const html = document.documentElement;
    let previousOverflow = '';
    trigger.addEventListener('click', () => {
      if (dialog.open) return;
      document.querySelectorAll('dialog[open]').forEach(other => other.close());
      previousOverflow = html.style.overflow;
      dialog.showModal();
      html.style.overflow = 'hidden';
      trigger.setAttribute('aria-expanded', 'true');
    });
    dialog.querySelector('[data-collection-filter-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const targets = [...dialog.querySelectorAll('a[href],button,input,select,textarea,[tabindex]')].filter(el => el.tabIndex >= 0 && !el.disabled && el.getClientRects().length);
      const first = targets[0], last = targets.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    dialog.addEventListener('close', () => {
      dialog.querySelectorAll('input').forEach(input => {
        if (input.type === 'checkbox') input.checked = input.defaultChecked;
        else input.value = input.defaultValue;
        input.setCustomValidity('');
      });
      dialog.querySelectorAll('[data-price-error]').forEach(error => { error.hidden = true; });
      html.style.overflow = previousOverflow;
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus({preventScroll: true});
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document));
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-collection-filter-drawer][open]').forEach(dialog => dialog.close());
  });
})();

